<script lang="ts">
  import { fade } from 'svelte/transition';
  import { asideShow } from '../../store/header.js';
  import { ListItem } from './index.js';
  import { Button } from '../index.js';
  import { browser } from '$app/environment';
  import type { UseFormattedProps } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
  export let textColor = '';
  export let backgroundColor = '';

  $: {
    if (browser) {
      try {
        if ($asideShow) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = 'auto';
          document.body.style.height = '100vh';
          document.body.style.width = '100vw';
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
</script>

{#if $asideShow}
  <aside
    style="background: {backgroundColor};color:{textColor};"
    transition:fade
  >
    {#if properties.links.active}
      <nav class="aside-nav-menu">
        <ul>
          {#each properties.links.items as link}
            <li style="color:var(--vlt-lp-text);">
              <ListItem
                on:click={() => asideShow.set(false)}
                on:keyup={ev => {
                  return true;
                }}
                url={link.url}
                label={link.label}
                type={link.type}
                nestedItems={link.nestedItems}
                showAll={true}
              />
            </li>
          {/each}
        </ul>
      </nav>
    {/if}

    <div class="aside-button">
      {#if properties.button.active}
        <Button
          isHeader
          section="aside"
          buttonType={properties.button.link_type}
          buttonLink={properties.button.link}
          buttonTitle={properties.button.label}
        />
      {/if}
    </div>
  </aside>
{/if}

<style>
  aside {
    border-top: 1px solid #eff0f6;
    border-bottom: 1px solid #eff0f6;
    background-color: var(--vlt-lp-background);
    display: flex;
    overflow: scroll;
    flex-direction: column;
    height: 100%;
    width: 100%;
    position: fixed;
    z-index: 60;
  }
  .aside-button {
    margin-top: 15px;
    padding: 24px;
  }
  ul li {
    list-style: none;
    font-size: 16px;
    line-height: 24px;
  }
  ul li:not(:first-child) {
    padding-top: 32px;
  }
  ul {
    width: auto;
    margin: 0;
    padding: 24px;
    padding-bottom: 80px;
  }
</style>
